// 应用商城接口
import request from '@/utils/request'

// UEditor富文本配置接口
export function ueditorHandleUrl() {
	return process.env.VUE_APP_BASE_API + process.env.VUE_APP_PREFIX_API_MALLSERVER + '/api/ueditor/handle'
}

// 应用商城上传文件
export function uploadMerchantFile() {
	return process.env.VUE_APP_BASE_API + process.env.VUE_APP_PREFIX_API_MALLSERVER + '/api/merchantFile/uploadFile'
}

// 应用商城预览文件
export function previewMerchantFile() {
	return process.env.VUE_APP_BASE_API + process.env.VUE_APP_PREFIX_API_MALLSERVER + '/api/merchantFile/previewFile?fileRecordId='
}

// 应用商城删除文件
export const deleteMerchantFile = data => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MALLSERVER + '/api/merchantFile/removeFile',
		method: 'post',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		data
	})
}

// 附件查询列表
export const queryMerchantFileList = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MALLSERVER + '/api/merchantFile/list',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 应用商城查询字典
export const queryMerchantDictionary = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MALLSERVER + '/api/merchantDictionary/list',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 应用商城提交风采、宣传订单
export const submitMerchantOrder = data => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MALLSERVER + '/api/merchantOrder/submitOrder',
		method: 'post',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		data
	})
}

// 应用商城查询风采、宣传订单列表
export const queryMerchantOrderList = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MALLSERVER + '/api/merchantOrder/pageTab',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 应用商城查询风采、宣传订单详情
export const queryMerchantOrderDetail = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MALLSERVER + '/api/merchantOrder/getById',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 查询发货进度
export const queryMerchantOrderDeliveryProgress = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MALLSERVER + '/api/merchantOrder/getByIdLc',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 查询（企业宣传、企业风采）金额及活动价格（100 企业宣传；200 企业风采；300 宣传头条；400 风采头条）
export const queryMerchantOrderPrice = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MEMBERSERVER + '/api/itemEventPromotion/mapBuyValueAddedServiceVO',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 提交开店申请或驳回后重新提交
export const submitMerchantShopApply = data => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MALLSERVER + '/api/merchantShopApply/submit',
		method: 'post',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		data
	})
}

// 提交店铺资料变更申请
export const changeSubmitMerchantShopApply = data => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MALLSERVER + '/api/merchantShopApply/changeSubmit',
		method: 'post',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		data
	})
}

// 提交闭店申请
export const closeSubmitMerchantShopApply = data => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MALLSERVER + '/api/merchantShopApply/closeSubmit',
		method: 'post',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		data
	})
}

// 查询当前用户店铺信息
export const queryMyShop = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MALLSERVER + '/api/merchantShop/myShop',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 查询当前用户最新店铺申请
export const queryMyLatestShopApply = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MALLSERVER + '/api/merchantShopApply/myLatestApply',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 查询店铺申请详情
export const queryMerchantShopApplyDetail = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MALLSERVER + '/api/merchantShopApply/getById',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 保存商品草稿
export const saveMerchantGoodsDraft = data => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MALLSERVER + '/api/merchantGoods/saveDraft',
		method: 'post',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		data
	})
}

// 提交商品上架
export const submitMerchantGoods = data => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MALLSERVER + '/api/merchantGoods/submit',
		method: 'post',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		data
	})
}

// 查询我的店铺商品分页
export const queryMyMerchantGoodsPage = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MALLSERVER + '/api/merchantGoods/myGoodsPage',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 查询商品详情
export const queryMerchantGoodsDetail = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MALLSERVER + '/api/merchantGoods/getById',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}

// 修改商品状态
export const updateMerchantGoodsState = data => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MALLSERVER + '/api/merchantGoods/updateState',
		method: 'post',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		data
	})
}
